module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news"
  }, [(_vm.link.toLowerCase().indexOf('http') > -1) ? _c('a', {
    staticClass: "image-link u-opacity lightbox",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require('../assets/' + _vm.image)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.link.toLowerCase().indexOf('http') < 0) ? _c('router-link', {
    staticClass: "image-link u-opacity lightbox",
    attrs: {
      "to": _vm.link
    }
  }, [_c('img', {
    attrs: {
      "src": require('../assets/' + _vm.image)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.link.toLowerCase().indexOf('http') > -1) ? _c('a', {
    staticClass: "lightbox",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.titolo)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.link.toLowerCase().indexOf('http') < 0) ? _c('router-link', {
    staticClass: "lightbox",
    attrs: {
      "to": _vm.link
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.titolo)
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._t("descrizione")], 2), _vm._v(" "), (_vm.link.toLowerCase().indexOf('http') > -1 && _vm.link != '#!') ? _c('a', {
    staticClass: "share",
    attrs: {
      "href": 'https://www.facebook.com/sharer.php?u=' + _vm.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/facebook_grey.svg"),
      "alt": "Facebook icon"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.link.toLowerCase().indexOf('http') < 0 && _vm.link != '#!') ? _c('a', {
    staticClass: "share",
    attrs: {
      "href": 'https://www.facebook.com/sharer.php?u=http://www.dapstudio.com/eng/page/' + _vm.link.split('/')[3] + '.html',
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/facebook_grey.svg"),
      "alt": "Facebook icon"
    }
  })]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7d7fd7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/News.vue
// module id = 365
// module chunks = 0